import React from "react";
import { CarouselHP } from "../HumanPractices/CarouselHP";

const ArticleEvents = () => {
  const itemsBioDay = [
    {
      title: "our presentation",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/2023-bioe-day-1.jpeg",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/2023-bioe-day-2.jpeg",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/2023-bioe-day-5.jpeg",
    },
    {
      title: "Poster presentation",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/2023-bioe-day-6.jpeg",
    },
    {
      title: "final apero",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/2023-bioe-day-7.jpeg",
    },
    {
      title: "Dj-Tee",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/2023-bioe-day-8.jpeg",
    },
  ];

  const itemsMakeConference = [
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/make1.jpeg",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/make3-2-grande.jpeg",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/make5-1.jpeg",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/make5.jpeg",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/make6.jpeg",
    },
  ];

  const itemsUNIL = [
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/humanpractices/unil1.jpeg",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/humanpractices/unil2.jpeg",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/humanpractices/unil3.jpeg",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/humanpractices/unil4.jpeg",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/humanpractices/unil5.jpeg",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/humanpractices/unil6.jpeg",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/humanpractices/unil7.jpeg",
    },
  ];

  const itemsMuenster = [
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/humanpractices/muensterprima.png",
    },
    {
      title: "Our Team presenting",
      icon: "https://static.igem.wiki/teams/4888/wiki/humanpractices/muenster1.jpg",
    },
    {
      title: "Posters presentation",
      icon: "https://static.igem.wiki/teams/4888/wiki/humanpractices/muenster2.jpg",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/humanpractices/muenster3.jpg",
    },
  ];

  const itemsZurich = [
    {
      title: "Presentation EPFL",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/zurich7.jpg",
    },
    {
      title: "Presentation EPFL",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/zurich8.jpg",
    },
    {
      title: "Presentation EPFL",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/zurich9.jpg",
    },
    {
      title: "Presentation UNIL",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/zurich1.jpg",
    },
    {
      title: "Presentation UNIL",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/zurich2.jpg",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/zurich3.jpg",
    },
    {
      title: "The judges",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/zurich4.jpg",
    },
    {
      title: "Presentation Zurich",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/zurich5.jpg",
    },
    {
      title: "Presentation Zurich",
      icon: "https://static.igem.wiki/teams/4888/wiki/events/zurich6.jpg",
    },
  ];

  const itemsJapan = [
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/humanpractices/heavymetals1.png",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/humanpractices/heavymetals2.png",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/humanpractices/heavymetals3.png",
    },
    {
      title: "",
      icon: "https://static.igem.wiki/teams/4888/wiki/humanpractices/heavymetals4.png",
    },
  ];

  return (
    <div>
      <div className="mb-20" id="intro">
        <p>
          We are delighted to share that Team 48C has been actively engaged in
          various events aimed at fostering discussions about our project and
          promoting collaboration for the betterment of synthetic biology. With
          a shared passion for sustainable solutions, we have participated in
          insightful gatherings, workshops, and forums, where we have not only
          presented our innovative project but also eagerly absorbed diverse
          perspectives and ideas from fellow participants. These interactions
          have not only enriched our project but have also solidified our
          commitment to creating a positive impact on society through collective
          effort. We are excited to carry on with our collaborative journey,
          working towards advocating a world where synthetic biology aligns with
          community interests and is comprehensible to all.
        </p>
        <h2 id="bio-events" className="mt-20">
          Events
        </h2>
        <hr className="dividergeneral mb-5" />
        <p>
          Explore our journey of active engagement within the realm of
          biology-focused events. We take pride in our participation, where we
          not only showcased our pioneering project but also gained invaluable
          insights from a significant segment of the scientific community. These
          events provided us with a platform to present our work and gather
          diverse opinions, propelling our project forward through constructive
          dialogue and expert feedback. As we continue on this path, we remain
          dedicated to fostering collaboration and contributing to the
          advancement of scientific understanding.
        </p>
        <div id="BIOENG" className="centered-image mb-10">
          <CarouselHP items={itemsBioDay} title="Bioengineering day" />
        </div>
        <p>
          Our team participated in the Bioengineering Day organized by EPFL at
          the SwissTech Center on the 4th September 2023. It was an occasion to
          listen to inspiring talks on the topic of protein design and to get in
          touch with the scientific community closest to us. We are very
          grateful for the opportunity that was given to us to present in that
          occasion our project, with a short presentation and the exposition of
          our poster. We had already presented our project at the iGEM Meet-ups,
          but the BioEngineering Day was the first time presenting in a room
          full of expert professors and PhDs and their feedback has been very
          helpful. At the end of the presentation in fact we had a Q&A session
          that helped us gain further perspective on how to present our project
          and gave us inputs for the wet-lab work.
        </p>
        <div className="centered-image mb-10" id="MAKE">
          <CarouselHP
            items={itemsMakeConference}
            title="MAKE projects conference"
          />
        </div>
        <p>
          On September 27th, we had the opportunity to showcase our project at
          the "MAKE projects in SV conference" held on our campus and organized
          by SV Industry, an association at EPFL dedicated to bridging the gap
          between students and potential career prospects in academia, labs, or
          industry. During this conference, we introduced iGEM to the attendees,
          shedding light on its significance, particularly within the context of
          EPFL. We then delved into the student perspective of participating in
          iGEM, discussing the skills they could acquire, the required mindset,
          and our team's organizational approach. Finally, we provided a
          detailed overview of our project's design and unveiled the educational
          video game we developed. Sharing our work with the community was a
          gratifying experience, and we were delighted to see a strong interest
          from many students who expressed their desire to potentially join iGEM
          in the future.
        </p>
        <h3 id="meet-ups"> iGEM Meet-ups </h3>
        <p>
          Our active participation in iGEM meet-ups across Europe highlights our
          commitment to fostering collaboration and innovation. At these events,
          we not only had the privilege of presenting our project but also
          gained valuable insights from fellow participants. These meet-ups
          offered a unique platform to exchange ideas and witness the
          presentations of other inspiring projects. By immersing ourselves in
          this collaborative environment, we were able to enhance our project
          approach, drawing from diverse perspectives and innovative approaches.
          As we reflect on our journey, we are grateful for the opportunities
          these meet-ups provided, which have undoubtedly contributed to our
          project's growth and refinement.
        </p>
        <div className="centered-image mb-10" id="meetup1">
          <CarouselHP items={itemsMuenster} title="Münster European Meet-up" />
        </div>
        <p>
          Our team decided to participate in the European meet-up at the
          beginning of August to confront ourselves with the other teams and
          their work. The objective of this confrontation was actively
          participate in the iGEM community and to correct the direction of our
          efforts during the rest of the summer if needed. It was our first
          direct interaction in the iGEM community and it was a great experience
          from every point of view. We found incredible people in the other
          teams and had great exchanges both from a scientific and human point
          of view. We are grateful to the Muenster team for organizing this
          meet-up. They organized an incredible meet-up where, in addition to
          the exchange with our peers and the teams presentations, we had the
          occasion to listen to very interesting lectures by their professors
          and to participate in workshops.
        </p>
        <div className="centered-image mb-10" id="meetup2">
          <CarouselHP items={itemsZurich} title="Zurich Swiss Meet-up" />
        </div>
        <p>
          The Swiss-meet up was the occasion for our team to exchange with the
          teams closer to us. We spent a weekend in Zurich getting to know the
          members of the other teams, discussing our projects and presenting
          them to iGEM alumni and TAs. Our project was at a more advanced stage
          opposed to the first presentation we did in Muenster. This, together
          with the reduced number of teams and the presence of judges dedicated
          specifically to our team, allowed us to get a more personal and
          complete feedback. The comments of the judges have been of great help
          for us, not only for the presentation itself, but also for how to
          present our project on the wiki. In particular the Q&A session that
          followed the presentation allowed us to realize the strong points of
          our project and what at the contrary still needed additional work. At
          the end of the meet-up, our presentation has been judged to be the
          best and most structured.
        </p>
        <div className="centered-image mb-10" id="meetup3">
          <CarouselHP items={itemsJapan} title="Heavy metals Meet-up" />
        </div>
        <p>
          We participated in the international heavy metals iGEM meet-up. As for
          the other meet-ups it started by presenting the different projects of
          the teams present. In the second part of the meet-up we discussed the
          possible collaborations. Our team proposed a collaboration for our
          video game, bioquest. We invited the other teams to send us a short
          description of the problems they were trying to solve in the wet-lab
          and the genes they used, in order to make addition levels using these
          informations. We also decided to participate in a second collaboration
          to translate the promotional videos and a third one to create a
          platform with the education materials produced by each team. This last
          collaboration was particularly interesting and important for our team,
          seen our continuous efforts in education to make synthetic biology
          more accessible to everybody.
        </p>
        <h2 id="collabs" className="mt-20">
          {" "}
          Collaborations
        </h2>
        <hr className="dividergeneral mb-5" />
        <h3 id="UNIL"> UNIL waste collection at Vidy</h3>
        <p>
          In our ongoing efforts to contribute to our community, we participated
          in cleanup of the beaches of Lake Léman, organised by the UNIL iGEM
          team. This joint endeavor exemplifies our commitment to environmental
          responsibility and underscores the effectiveness of collective action.
        </p>
        <div className="centered-image mb-10" id="collect">
          <CarouselHP items={itemsUNIL} title="UNIL waste collection at Vidy" />
        </div>
        <h3 id="game"> Thessaloniki game collaboration</h3>
        <p>
          We collaborated with the Thessaloniki IGEM team to add a level and a
          minigame. This team work on a hydrogel to spread on the soil after a
          wildfire, to rehydrate it and help the recovery. The team worked on
          encapsulation of two different strains of bacteria in the hydrogel. We
          used this concept to contruct a minigame. For the level, we worked on
          corum sensing. In their project, the two strain communicate with each
          other using a corum sensing method, that the team enginnered using
          synthetic biology.
        </p>
        <h3 id="subtitles"> IIT Delhi promotion video collaboration</h3>
        <p>
          We engaged in a collaborative effort with the IIT Delhi team to create
          our promotional videos. In return for their provision of Hindi
          subtitles for our videos, we reciprocated by translating their
          subtitles into French.
        </p>
      </div>
    </div>
  );
};

export default ArticleEvents;
